import React from 'react';

import {
  useLocation,
  useNavigate
} from 'react-router-dom';

import { LoadingOverlay } from 'iron-forge-react-modules';
import { routeDirectory } from '../../routeDirectory';

import * as dataService from './dataService';



export interface IProps {
  children: React.ReactNode | React.ReactNode[];
  type: 'onlyAllowLoggedOutUsers' | 'onlyAllowLoggedInUsers';
  redirectLoggedInUserToRoute?: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery();
  const navigate = useNavigate();
  const [showContent, setShowContent] = React.useState(false);
  const location = useLocation();



  React.useEffect(
    () => {
      if (props.type === 'onlyAllowLoggedOutUsers') {
        if (queryTuple.authStatus === 'loggedIn') {
          navigate(props.redirectLoggedInUserToRoute ?? routeDirectory.root.path());
        } else if (!showContent) {
          setShowContent(true);
        }

      } else {
        if (queryTuple.authStatus === 'loggedIn' && queryTuple.didCall && !queryTuple.loading) {
          if (!queryTuple.canView) {
            if (!location.pathname.startsWith(routeDirectory.accessDenied.path())) {
              navigate(routeDirectory.accessDenied.path());
            }

          } else {
            if (location.pathname.startsWith(routeDirectory.accessDenied.path())) {
              navigate(routeDirectory.admin.root.path());
            } else if (!showContent) {
              setShowContent(true);
            }
          }
        }
      }
    },
    [
      navigate,
      queryTuple,
      location,
      props.type,
      props.redirectLoggedInUserToRoute,
      showContent
    ]);



  return showContent ? (
    <>
      {props.children}
    </>
  ) : (
    <LoadingOverlay.FC active />
  );
};
